import { IOption } from "models/Form";

export const UPLOAD_CATEGORY: IOption[] = [
  { id: 1, label: "Signed Bill of Lading (Delivered)", value: "Signed Bill of Lading (Delivered)" },
  { id: 2, label: "Signed Bill of Lading (Pick-Up)", value: "Signed Bill of Lading (Pick-Up)" },
  { id: 3, label: "Rate Confirmation", value: "rate_confirmation" },
  { id: 4, label: "Truck Order Not Used", value: "truck_order_not_used" },
  { id: 5, label: "Invoice", value: "invoice" },
  { id: 6, label: "Freight Bill", value: "freight_bill" },
  { id: 7, label: "Fuel Advance", value: "fuel_advance" },
  { id: 8, label: "Lumper Receipt", value: "lumper_receipt" },
  { id: 9, label: "Detention Receipt", value: "detention_receipt" },
  { id: 10, label: "Late Fee Receipt", value: "late_fee_receipt" },
  { id: 11, label: "Other", value: "other" }
];

export const CUSTOMER_CATEGORY: IOption[] = [
  { id: 1, label: "Shipper Acknowledgement", value: "Shipper Acknowledgement" },
  { id: 2, label: "Other", value: "Other" }
];

export const NEW_CARRIER_CATEGORY: IOption[] = [
  { id: 0, label: "License", value: "driver_license" },
  { id: 1, label: "Insurance", value: "insurance" },
  { id: 2, label: "Void Check", value: "voided_check" },
  { id: 3, label: "NOA", value: "noa" },
  { id: 4, label: "Other", value: "" }
];

export const ORDER_LIST = [
  {
    id: 0,
    name: "Age",
    managePay: "-created",
    history: "-created",
    assignedLoads: "-created"
  },
  {
    id: 1,
    name: "A to Z",
    managePay: "debtor",
    history: "billTo",
    assignedLoads: "billTo"
  },
  {
    id: 2,
    name: "Z to A",
    managePay: "-debtor",
    history: "-billTo",
    assignedLoads: "-billTo"
  },
  {
    id: 3,
    name: "High to Low Amount",
    managePay: "-amount",
    history: "-amount",
    assignedLoads: "-amount"
  },
  {
    id: 4,
    name: "Low to High Amount",
    managePay: "amount",
    history: "amount",
    assignedLoads: "amount"
  }
];

export const CARRIER_FR_STATUS_LABELS: { [key in string]: string } = {
  incomplete: "Incomplete",
  new: "New",
  new_noa: "Pending NOA",
  fuel_advance: "Fuel Advance",
  document_issue: "Document Issue",
  document_review: "Document Review",
  hold: "Hold",
  pending_originals: "Pending Originals",
  pending: "Pending",
  non_factored: "Non Factored",
  remote_approved: "Approved",
  approved: "Approved",
  paid: "Paid",
  declined: "Declined",
  pending_delivery: "Incomplete",
  closed: "Closed",
  all: "All"
};

export const BROKER_FR_STATUS_LABELS: { [key in string]: string } = {
  incomplete: "Incomplete",
  hold: "Hold",
  non_factored: "Non Factored",
  document_issue: "Document Issue",
  pending_originals: "Pending Originals",
  pending: "Pending",
  fuel_advance: "Fuel Advance",
  remote_approved: "Approved",
  carrier_paid: "Carrier Paid",
  invoice_paid: "Invoice Paid",
  paid: "Paid",
  declined: "Declined",
  all: "All"
};

export const COLOR_BY_STATUS: { [key in string]: string } = {
  Pending: "text-pendingBorder border-pendingBorder",
  Hold: "text-pendingBorder border-pendingBorder",
  "Special Pending": "text-pendingBorder border-pendingBorder",
  "Pending NOA": "text-pendingBorder border-pendingBorder",
  "Pending Originals": "text-pendingBorder border-pendingBorder",
  Incomplete: "text-declinedBorder border border-declinedBorder",
  "Pending Delivery": "text-declinedBorder border border-declinedBorder",
  Declined: "text-declinedBorder border border-declinedBorder",
  Paid: "text-approvedBorder border border-approvedBorder",
  Closed: "text-approvedBorder border border-approvedBorder",
  "Invoice Paid": "text-approvedBorder border border-approvedBorder",
  "Carrier Paid": "text-approvedBorder border border-approvedBorder",
  Approved: "text-approvedBorder border border-approvedBorder",
  "Remote Approved": "text-approvedBorder border border-approvedBorder",
  "Document Issue": "text-subtitle border border-subtitle",
  "Document Review": "text-info border border-info",
  "Non Factored": "text-subtitle border border-subtitle"
};

export const COLOR_BY_STATUS_FOR_MY_CARRIER: { [key in string]: string } = {
  pending: "text-pendingBorder border border-pendingBorder",
  declined: "text-declinedBorder border border-declinedBorder",
  approved: "text-approvedBorder border border-approvedBorder",
  needs_review: "text-info border border-info"
};
